<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="searchBox inpBox">
            <el-form-item label="司机姓名:" prop="driverName">
                <el-input  placeholder="" v-model="searchFrom.driverName"></el-input>
              </el-form-item>
                <el-form-item label="车牌号:" prop="vchNo">
                <el-input  placeholder="" v-model="searchFrom.vchNo"></el-input>
              </el-form-item>
              <el-form-item label="联系电话:" prop="driverMobile">
                <el-input  placeholder="" v-model="searchFrom.driverMobile"></el-input>
              </el-form-item>
        </div>
       <div class="searchBtnBox">
         <el-form-item>
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" >
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" center border :row-class-name="tableRowClassName">
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column prop="driverName" :formatter="emptyFn" width="200" :show-overflow-tooltip="true"  label="司机姓名"></el-table-column>
        <el-table-column prop="vhcNo" :formatter="emptyFn"  width="150" label="车牌号"></el-table-column>
         <el-table-column prop="driverMobile" :formatter="emptyFn" width="200" label="联系电话"></el-table-column>
        <el-table-column prop="vhcTypeName" :formatter="emptyFn"  width="160" :show-overflow-tooltip="true" label="车辆类型"></el-table-column>
         <el-table-column prop="standardsName" :formatter="emptyFn" width="160" :show-overflow-tooltip="true" label="排放标准"></el-table-column>
         <el-table-column prop="signinTime"  min-width="170" :formatter="dateFormat"  label="报号时间"></el-table-column>
      </el-table>
    </div>

 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { driverSigninList } from '@/api/vgs-driver'
import { emptyFn } from '@/utils/util'
export default {
  data () {
    return {
      emptyFn: emptyFn,
      tableList: [],
      searchFrom: {},
      btnFlg: [],
      btnIdArr: ['004P003B000', '004P003B001', '004P003B002']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/systemSetup/address')
    this.getList(this.searchFrom)
  },
  mounted () {

  },
  methods: {
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },

    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      driverSigninList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },

    closeDialog () {
      this.addFrom = {}
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.signinTime) {
        return 'warning-row'
      } else {
        return ''
      }
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null) {
        str = '-'
      } else {
        str =
          t.getFullYear() +
          '-' +
          month +
          '-' +
          date +
          ' ' +
          hour +
          ':' +
          minutes +
          ':' +
          seconds
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
/deep/.el-table .warning-row {
    background: rgba(37, 204, 127, 0.55)!important;
  }
</style>
